// src/main.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Import security utility
import securityUtils from './utils/securityUtils';

// Initialize security measures
securityUtils.initialize();

// Simpler preloading - just log that we're not doing it
console.log('Daily.co preloading disabled to prevent build errors');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
